export default class Cache {
    // eslint-disable-next-line class-methods-use-this
    static set(key, value, lifetime) {
        const time = lifetime || (15 * 60 * 1000);
        localStorage.setItem(`lifetime.${key}`, (new Date()).getTime() + time);
        localStorage.setItem(key, JSON.stringify(value));
    }

    // eslint-disable-next-line class-methods-use-this
    static get(key) {
        const time = parseInt(localStorage.getItem(`lifetime.${key}`), 10);

        if (time && time > (new Date()).getTime()) {
            return JSON.parse(localStorage.getItem(key)) || null;
        }

        return null;
    }

    static delete(key) {
        localStorage.removeItem(key);
    }

    static flush() {
        localStorage.clear();
    }
}
